import React from "react";
import styled from "styled-components";
import { DatePickerInput, Form, Label, LabelInput, Select } from "../../common/components/form";
import Button from "../../../ui/button/Button";

import { Localize } from "../../../locale/localization";
import { media } from "../../../utils/uiSizes";
import { formatProductDisplayName } from "../../../utils/content-utils";

const SalesButton = styled(Button)`
  padding: 1.125rem 1.5625rem;
  margin-top: 0 !important;

  ${media.tablet`
    margin-right: -5rem;
  `} .icon-wrap {
    padding-right: 0;
  }

  &.disabled {
    opacity: 1;
  }
`;

const CreateTransactionForm = props => {
  const {
    enabled,
    fieldsEnabled,
    onSubmit,
    onBlur,
    onInputChange,
    errors,
    touchedFields,
    isValid,
    products,
    productCategories,
    selectedProductCategory,
    selectedProduct,
    quantity,
    date,
    firstPossibleDate,
    lastPossibleDate,
    salesId
  } = props;

  const categoryOptions = productCategories.map(category => (
    <option key={category._id} value={category._id}>
      {category.name}
    </option>
  ));
  const productOptions = selectedProductCategory
    ? products
        .filter(product => product.productCategory === selectedProductCategory)
        .map(product => (
          <option key={product._id} value={product._id}>
            {formatProductDisplayName(product)}
          </option>
        ))
    : null;

  return (
    <Form
      onSubmit={onSubmit}
      autoCorrect="off"
      autoComplete="off"
      noValidate
      spellCheck="false"
      onBlur={onBlur}
    >
      <h2>Ilmoita myynti</h2>
      <Select
        disabled={!fieldsEnabled}
        value={selectedProductCategory}
        name="selectedProductCategory"
        error={
          errors["selectedProductCategory"] && touchedFields.indexOf("selectedProductCategory") > -1
        }
        errorMessage={errors["selectedProductCategory"]}
        onChange={onInputChange}
      >
        <option value="">{Localize("package")}</option>
        {categoryOptions}
      </Select>
      <Select
        disabled={!selectedProductCategory || !fieldsEnabled}
        value={selectedProduct}
        name="selectedProduct"
        error={errors["selectedProduct"] && touchedFields.indexOf("selectedProduct") > -1}
        errorMessage={errors["selectedProduct"]}
        onChange={onInputChange}
      >
        <option value="">{Localize("type")}</option>
        {productOptions}
      </Select>
      <LabelInput
        disabled={!fieldsEnabled}
        half
        tight
        type="text"
        label={Localize("amount")}
        name="quantity"
        value={quantity}
        error={errors["quantity"] && touchedFields.indexOf("quantity") > -1}
        errorMessage={errors["quantity"]}
        onChange={onInputChange}
      />
      <Label half tight label={Localize("date")}>
        <DatePickerInput
          disabled={!fieldsEnabled}
          type="text"
          name="date"
          strict={true}
          value={date}
          error={errors["date"] && touchedFields.indexOf("date") > -1}
          errorMessage={errors["date"]}
          onChange={onInputChange}
          firstPossibleDate={firstPossibleDate}
          lastPossibleDate={lastPossibleDate}
        />
      </Label>
      <div style={{ marginTop: "-1rem", marginBottom: "-2rem", width: "100%" }}>
        <LabelInput
          half
          tight
          type="text"
          label={Localize("id")}
          name="salesId"
          value={salesId}
          onChange={onInputChange}
        />
      </div>
      <footer>
        <SalesButton
          disabled={!isValid || !enabled}
          type="submit"
          icon="#chevron-right"
          iconRight={true}
          theme="large"
        >
          {Localize("action.sale.add")}
        </SalesButton>
      </footer>
    </Form>
  );
};

export default CreateTransactionForm;



// WEBPACK FOOTER //
// ./src/modules/transaction/components/CreateTransactionForm.js